








































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiMaterialDetail, apiMaterialInventoryStats } from '@/api/material'

@Component
export default class MaterialDetail extends Vue {
    materialId = ''
    detailData: any = {}
    inventoryTab = 'overview'
    inventoryStats: any = {}
    batchList: any[] = []

    getMaterialDetail () {
      apiMaterialDetail({ id: this.materialId }).then((res: any) => {
        this.detailData = res || {}
      })
    }

    getInventoryStats () {
      apiMaterialInventoryStats({ material_id: this.materialId }).then((res: any) => {
        this.inventoryStats = res?.data?.stats || {}
        this.batchList = res?.data?.batch_list || []
      })
    }

    getMaterialTypeText (type: number): string {
      const types = ['', '普通物料', '批次管理物料', '序列号管理物料']
      return types[type] || '未知'
    }

    getStatusText (status: number): string {
      const statusMap = ['', '正常', '停用', '淘汰']
      return statusMap[status] || '未知'
    }

    getStatusTagType (status: number): string {
      const typeMap = ['', 'success', 'info', 'warning']
      return typeMap[status] || ''
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    formatDate (row: any, column: any, cellValue: any): string {
      if (!cellValue) {
        return '--'
      }
      const date = new Date(cellValue * 1000)
      return date.toLocaleDateString()
    }

    created () {
      this.materialId = this.$route.query.id as string
      if (this.materialId) {
        this.getMaterialDetail()
        this.getInventoryStats()
      }
    }
}
